(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ppd-featured-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ppd-timed-offer')) {
    class PpdTimedOffer extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        window.addEventListener('pageshow', () => this.refresh(), options);
        document.addEventListener('visibilitychange', () => this.refresh(), options);
        this.refresh();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
      }
      refresh() {
        clearTimeout(this.timer);
        const offer = this.querySelector('[data-ppd-offer]');
        const fallback = this.querySelector('[data-ppd-fallback]');
        const endsAt = Date.parse(this.dataset.expiresAt);
        const remaining = endsAt - Date.now();
        const active = Boolean(offer) && Number.isFinite(endsAt) && remaining > 0;
        if (offer) offer.hidden = !active;
        if (fallback) fallback.hidden = active;
        if (active) this.timer = setTimeout(() => this.refresh(), Math.min(remaining, 3600000));
      }
    }
    customElements.define('ppd-timed-offer', PpdTimedOffer);
  }
  } catch(e) { console.error(e); }
})();

})();
